import { useMemo } from 'react'
import Image from 'next/image'

/* blocks */
import Link from '@/atoms/Link/Link'
import Carousel from '@/cmp/templates/VideoMarketing/components/Carousel/Carousel'

/* utils */
import { SimilarEventsPageAttributes } from '@/utils/queries/individual-events-page'

interface Props {
  title: string
  lists: SimilarEventsPageAttributes[]
}

function SimilarEvents({ title, lists }: Props) {
  const slides = useMemo(() => {
    return lists.map(list => <Slide list={list} key={list.slug} />)
  }, [lists])

  return (
    <section className="font-heading">
      <div className="container | py-10 md:py-18">
        <h3 className="text-2xl md:text-3xl font-semibold text-blue-web-90">
          {title}
        </h3>
      </div>
      <div>
        <Carousel
          navigationType="arrow"
          sliderClassName="mb-10 md:first:ml-10 px-4 md:px-0"
          buttonConfig={{
            prevButtonClassName: 'text-blue-50',
            nextButtonClassName: 'text-blue-50'
          }}
          slides={slides}
        />
      </div>
    </section>
  )
}

const Slide = ({ list }: { list: SimilarEventsPageAttributes }) => {
  return (
    <div key={list.eventType}>
      <Link href={`/events/${list.slug}`}>
        <div className="snap-center | bg-white border border-gray-40 hover:border-blue-web-50 | transition-colors delay-200 ease-in shadow-md rounded-lg | lg:max-w-2xl | relative">
          <Image
            src={list.eventThumbnailImage.data.attributes.url ?? ''}
            alt={list.eventThumbnailImage.data.attributes.alternativeText ?? ''}
            width={list.eventThumbnailImage.data.attributes.width}
            height={list.eventThumbnailImage.data.attributes.height}
            className="rounded-t-lg"
          />
        </div>
      </Link>
    </div>
  )
}

export default SimilarEvents
